module.exports = __webpack_public_path__ + "static/join_international_obj03@2x-00d2d8d57d612b0b7b71c6154d3aed2e.png";